// extracted by mini-css-extract-plugin
module.exports = {"timer__sliding":"timer__sliding-3b_N8","timer__link":"timer__link--tsRp"};